import React, { Component } from 'react';
import Overlay from 'Components/Overlay';
import Input from 'Components/Input';
import Select from 'react-select';
import './UpdateBusinessVolume.scss';

export default class UpdateBusinessVolume extends Component {

  onChangeValue = (e) => {
    const value = e.target.value;
    if (value < 0) return;
    this.props.onChange('value', value);
  };

  onSelectUnit = (selectedOption) => {
    console.log('Selected option:', selectedOption);

    if (selectedOption) {
      this.props.onChange('unit', selectedOption.value);
      this.props.onChange('name', selectedOption.label);
    } else {
      // Handle clear
      this.props.onChange('unit', null);
      this.props.onChange('name', '');
    }
  };

  render() {
    const {
      businessVolume,
      businessVolumes = [],
      onCancel,
      onSaveBusinessVolume
    } = this.props;

    // Transform businessVolumes to react-select format
    const options = businessVolumes.map(bv => ({
      value: bv.value,
      label: bv.name
    }));

    // Find the selected option
    const selectedOption = options.find(
      option => option.value === businessVolume.unit
    ) || null;

    console.log('Current businessVolume:', businessVolume);
    console.log('Selected option:', selectedOption);

    return (
      <Overlay>
        <div className="update-business-volume">

          <div className="update-business-volume__title">
            Update Business Volume
          </div>

          <div className="update-business-volume__row">

            <Input
              placeholder="Eg. 100"
              value={businessVolume.value || ''}
              onChange={this.onChangeValue}
              type="number"
            />

            <Select
              options={options}
              value={selectedOption}
              onChange={this.onSelectUnit}
              placeholder="Select Unit"
              isClearable
              className="wt-250"
            />

          </div>

          <div className="update-business-volume__actions">
            <button className="btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button className="btn-primary" onClick={onSaveBusinessVolume}>
              Save
            </button>
          </div>

        </div>
      </Overlay>
    );
  }
}